import { initContract } from "@ts-rest/core";
import { CreatedTimeAwayTypeList } from "../validators/leave-type.validators";

const c = initContract();

export const leaveTypeContract = c.router({
	getLeaveType: {
		method: "GET",
		path: "/leave-types",
		responses: {
			200: c.type<CreatedTimeAwayTypeList>(),
		},
	},
});
